<template><expense-list scope="all" /></template>
<script>
import ExpenseList from './list'
export default { name: 'ExpenseLedger', components: { ExpenseList } }
</script>
